import { css } from "@emotion/react";

export const mainContainer = css`
    display: flex;
    width: 200px;
    min-height: 720px;
    padding: 10px;
`